import React from 'react';
import VisaLogo from './Visa.svg';
import QITechBG from './QITechBG.svg';
import * as S from './styles';

interface CreditCardProps {
    primaryColor: string;
    secondaryColor: string;
    label: string;
    lastDigits: string;
    holderName: string;
    limitValue?: string;
    textColor?: string;
    limitLabel?: string;
}

export const CreditCard = ({
    primaryColor,
    secondaryColor,
    label,
    lastDigits,
    holderName,
    textColor,
    limitValue,
    limitLabel,
}: CreditCardProps) => (
    <S.Wrapper>
        <S.Card $color={primaryColor}>
            <S.BackgroundArt src={QITechBG} alt="" />

            <S.TopRow>
                <S.Label>{label}</S.Label>
                <S.VisaImage src={VisaLogo} alt="Visa" />
            </S.TopRow>

            <S.NumberRow>
                <S.MaskedGroup>* * * *</S.MaskedGroup>
                <S.MaskedGroup>* * * *</S.MaskedGroup>
                <S.MaskedGroup>* * * *</S.MaskedGroup>
                <S.LastDigits>{lastDigits}</S.LastDigits>
            </S.NumberRow>

            <S.HolderName>{holderName}</S.HolderName>
        </S.Card>

        {limitValue && (
            <S.LimitBadge $color={primaryColor} $borderColor={textColor}>
                <S.LimitValue $color={secondaryColor}>{limitValue}</S.LimitValue>
                {limitLabel && <S.LimitLabel $color={textColor}>{limitLabel}</S.LimitLabel>}
            </S.LimitBadge>
        )}
    </S.Wrapper>
);
